// 全身鏡: 上から見てH型（2本の足スタンドと中央の鏡）
import { Box } from '@react-three/drei'

export default function FullMirrorMesh({ width, height, depth, position, color, isSelected }) {
    // 上から見てH型の構造
    // - 左右2本のスタンド（底面で奥行き方向に伸びる、高さはポールの太さと同じ）
    // - 鏡はHの横棒部分（中央に立つ）

    const poleWidth = width * 0.06            // ポールの太さ
    const standHeight = poleWidth             // スタンドの高さ（ポールの太さと同じ）
    const mirrorHeight = height - standHeight // 鏡の高さ（スタンドの上から上端まで）
    const mirrorThickness = depth * 0.05      // 鏡の厚さ

    // Y座標計算
    const standY = position[1] - height / 2 + standHeight / 2  // スタンドは底面
    const mirrorY = position[1] - height / 2 + standHeight + mirrorHeight / 2  // 鏡はスタンドの上から

    return (
        <group>
            {/* 左スタンド（底面、奥行き方向に伸びる足） */}
            <Box args={[poleWidth, standHeight, depth]} position={[-width / 2 + poleWidth / 2, standY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 右スタンド（底面、奥行き方向に伸びる足） */}
            <Box args={[poleWidth, standHeight, depth]} position={[width / 2 - poleWidth / 2, standY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 鏡面（Hの横棒部分、中央に立つ） */}
            <Box args={[width, mirrorHeight, mirrorThickness]} position={[0, mirrorY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 左スタンド */}
            <Box args={[poleWidth, standHeight, depth]} position={[-width / 2 + poleWidth / 2, standY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 右スタンド */}
            <Box args={[poleWidth, standHeight, depth]} position={[width / 2 - poleWidth / 2, standY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 鏡面 */}
            <Box args={[width, mirrorHeight, mirrorThickness]} position={[0, mirrorY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
